module.exports = __webpack_public_path__ + "static/media/baba.37ed4349.png";